import React from 'react'
import { Alert, Snackbar, Stack } from '@mui/material'
import { ErrorMessage } from '../hooks/useErrorManager'
import { ERROR_MAX_DISPLAY } from '../Config/layoutConstants'

interface ErrorDisplayProps {
  errors: ErrorMessage[]
  onDismiss: (id: string) => void
  position?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'center' | 'right'
  }
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  errors,
  onDismiss,
  position = { vertical: 'top', horizontal: 'right' },
}) => {
  if (errors.length === 0) {
    return null
  }

  return (
    <Snackbar
      open={errors.length > 0}
      anchorOrigin={position}
      sx={{ maxWidth: '500px' }}
    >
      <Stack spacing={1} sx={{ width: '100%' }}>
        {errors.slice(-ERROR_MAX_DISPLAY).map((error) => (
          <Alert
            key={error.id}
            severity={error.type}
            onClose={() => onDismiss(error.id)}
            sx={{ width: '100%' }}
          >
            {error.message}
          </Alert>
        ))}
      </Stack>
    </Snackbar>
  )
}

export default ErrorDisplay
